/**
 * 运营商 | 子运营商 | 运营商配置 | 权益包 | 白名单
 */
import Net from '../net';

const NAME = '[OperatorApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === Operator === **/
/** user/operator-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.username
 * @param {*} data.phone
*/
export async function getOperatorList(data = {}) {
  Log('getOperatorList data:', data)
  try {
    const res = await Net.http('user/operator-list', { data })
    Log('getOperatorList res:', res)
    return res
  } catch (err) {
    Log('getOperatorList err:', err)
    throw err
  }
}

/** user/operator-list-all
 * @param {Object} data
 * @param {*} data.username
*/
export async function getOperatorListAll(data = {}) {
  Log('getOperatorListAll data:', data)
  try {
    const res = await Net.http('user/operator-list-all', { data })
    Log('getOperatorListAll res:', res)
    return res
  } catch (err) {
    Log('getOperatorListAll err:', err)
    throw err
  }
}

/** user/operator-list-all
 * @param {Object} data
 * @param {*} data.username
*/
export async function getOperatorListAllMain(data = {}) {
  Log('getOperatorListAllMain data:', data)
  try {
    const res = await Net.http('user/operator-list-all', { data })
    Log('getOperatorListAllMain res:', res)
    return res
  } catch (err) {
    Log('getOperatorListAllMain err:', err)
    throw err
  }
}

/** operator/sub-operator-list
 * @param {Object} data
*/
export async function operatorSubList(data = {}) {
  Log('operatorSubList data:', data)
  try {
    const res = await Net.http('operator/sub-operator-list', { data })
    Log('operatorSubList res:', res)
    return res
  } catch (err) {
    Log('operatorSubList err:', err)
    throw err
  }
}

/** admin/1/operator/create
 * @param {Object} data
 * @param {*} data.mode 运营商模式
 * @param {*} data.username 登录账号
 * @param {*} data.password 登录密码
 * @param {*} data.name 运营商名称
 * @param {*} data.phone 手机号
 * @param {*} data.avatar 头像
 * @param {*} data.gender 性别
 * @param {*} data.province 省
 * @param {*} data.city 市
 * @param {*} data.county 区/县
 * @param {*} data.real_name 真实姓名 v1
 * @param {*} data.pay_config 支付配置 v1
 * @param {*} data.admin_logo 管理端 Logo
 * @param {*} data.admin_name 管理端名称
 * @param {*} data.app_name App 名称
 * @param {*} data.app_contact App 联系方式
 * @param {*} data.company_name 公司名称
*/
export async function createOperator(data = {}) {
  Log('createOperator data:', data)
  try {
    const res = await Net.http('operator/create', { data })
    Log('createOperator res:', res)
    return res
  } catch (err) {
    Log('createOperator err:', err)
    throw err
  }
}

/** admin/2/operator/create
 * @param {Object} data
 * @param {*} data.mode 运营商模式
 * @param {*} data.username 登录账号
 * @param {*} data.password 登录密码
 * @param {*} data.name 运营商名称
 * @param {*} data.phone 手机号
 * @param {*} data.avatar 头像
 * @param {*} data.gender 性别
 * @param {*} data.province 省
 * @param {*} data.city 市
 * @param {*} data.county 区/县
 * @param {*} data.real_name 真实姓名 v1 已废弃
 * @param {*} data.pay_config 支付配置 v1 已废弃
 * @param {*} data.admin_logo 管理端 Logo
 * @param {*} data.admin_name 管理端名称
 * @param {*} data.app_name App 名称
 * @param {*} data.app_contact App 联系方式
 * @param {*} data.company_name 公司名称
 * @param {*} data.account_opening_info 开户资料 v2
*/
export async function createOperatorV2(data = {}) {
  Log('createOperatorV2 data:', data)
  try {
    const res = await Net.http('operator/create', { data, versionMark: 2 })
    Log('createOperatorV2 res:', res)
    return res
  } catch (err) {
    Log('createOperatorV2 err:', err)
    throw err
  }
}

/** operator/detail
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function getOperatorDetail(data = {}) {
  Log('getOperatorDetail data:', data)
  try {
    const res = await Net.http('operator/detail', { data })
    Log('getOperatorDetail res:', res)
    return res
  } catch (err) {
    Log('getOperatorDetail err:', err)
    throw err
  }
}

/** operator/detail-by-id
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function getOperatorDetailById(data = {}) {
  Log('getOperatorDetailById data:', data)
  try {
    const res = await Net.http('operator/detail-by-id', { data })
    Log('getOperatorDetailById res:', res)
    return res
  } catch (err) {
    Log('getOperatorDetailById err:', err)
    throw err
  }
}

/** operator/check
 * @param {Object} data
 * @param {*} data.username
 * @param {*} data.phone
*/
export async function checkOperator(data = {}) {
  Log('checkOperator data:', data)
  try {
    const res = await Net.http('operator/check', { data })
    Log('checkOperator res:', res)
    return res
  } catch (err) {
    Log('checkOperator err:', err)
    throw err
  }
}

/** operator/check-uid-is-empty
 * @param {Object} data
*/
export async function operatorUidCheck(data = {}) {
  Log('operatorUidCheck data:', data)
  try {
    const res = await Net.http('operator/check-uid-is-empty', { data })
    Log('operatorUidCheck res:', res)
    return res
  } catch (err) {
    Log('operatorUidCheck err:', err)
    throw err
  }
}

/** operator/find-parent-list
 * @param {Object} data
*/
export async function findOperatorParentList(data = {}) {
  Log('findOperatorParentList data:', data)
  try {
    const res = await Net.http('operator/find-parent-list', { data })
    Log('findOperatorParentList res:', res)
    return res
  } catch (err) {
    Log('findOperatorParentList err:', err)
    throw err
  }
}

/** operator/refresh-token
 * @param {Object} data
*/
export async function refreshOperatorToken(data = {}) {
  Log('refreshOperatorToken data:', data)
  try {
    const res = await Net.http('operator/refresh-token', { data })
    Log('refreshOperatorToken res:', res)
    return res
  } catch (err) {
    Log('refreshOperatorToken err:', err)
    throw err
  }
}

/** operator/reset-password
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.password
*/
export async function resetOperatorPassword(data = {}) {
  Log('resetOperatorPassword data:', data)
  try {
    const res = await Net.http('operator/reset-password', { data })
    Log('resetOperatorPassword res:', res)
    return res
  } catch (err) {
    Log('resetOperatorPassword err:', err)
    throw err
  }
}

/** operator/change-password
 * @param {Object} data
 * @param {*} data.password
*/
export async function changeOperatorPassword(data = {}) {
  Log('changeOperatorPassword data:', data)
  try {
    const res = await Net.http('operator/change-password', { data })
    Log('changeOperatorPassword res:', res)
    return res
  } catch (err) {
    Log('changeOperatorPassword err:', err)
    throw err
  }
}

/** operator/update-phone
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.phone
*/
export async function changeOperatorPhone(data = {}) {
  Log('changeOperatorPhone data:', data)
  try {
    const res = await Net.http('operator/update-phone', { data })
    Log('changeOperatorPhone res:', res)
    return res
  } catch (err) {
    Log('changeOperatorPhone err:', err)
    throw err
  }
}

/** operator/find-back-password
 * @param {Object} data
 * @param {*} data.username
 * @param {*} data.phone
 * @param {*} data.code
 * @param {*} data.new_pwd
*/
export async function findOperatorBackPassword(data = {}) {
  Log('findOperatorBackPassword data:', data)
  try {
    const res = await Net.http('operator/find-back-password', { data })
    Log('findOperatorBackPassword res:', res)
    return res
  } catch (err) {
    Log('findOperatorBackPassword err:', err)
    throw err
  }
}

/** operator/update/operator-username
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.new_username
*/
export async function changeOperatorLoginName(data = {}) {
  Log('changeOperatorLoginName data:', data)
  try {
    const res = await Net.http('operator/update/operator-username', { data })
    Log('changeOperatorLoginName res:', res)
    return res
  } catch (err) {
    Log('changeOperatorLoginName err:', err)
    throw err
  }
}

/** operator/service-charge/pay
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.money
*/
export async function operatorServicePay(data = {}) {
  Log('operatorServicePay data:', data)
  try {
    const res = await Net.http('operator/service-charge/pay', { data })
    Log('operatorServicePay res:', res)
    return res
  } catch (err) {
    Log('operatorServicePay err:', err)
    throw err
  }
}

/** operator/set-enable-ad
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_ids
 * @param {*} data.flag_ad
*/
export async function setOperatorAdFlag(data = {}) {
  Log('setOperatorAdFlag data:', data)
  try {
    const res = await Net.http('operator/set-enable-ad', { data })
    Log('setOperatorAdFlag res:', res)
    return res
  } catch (err) {
    Log('setOperatorAdFlag err:', err)
    throw err
  }
}

/** operator/set-operator-service-rate
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function setOperatorOrderSerRateFlag(data = {}) {
  Log('setOperatorOrderSerRateFlag data:', data)
  try {
    const res = await Net.http('operator/set-operator-service-rate', { data })
    Log('setOperatorOrderSerRateFlag res:', res)
    return res
  } catch (err) {
    Log('setOperatorOrderSerRateFlag err:', err)
    throw err
  }
}

/** operator/set-commission-rate
 * @param {Object} data
 * @param {*} data.target_id
 * @param {*} data.commission_rate
 * @param {*} data.order_service_fee_max_money
 * @param {*} data.order_service_fee_min_money
*/
export async function setOperatorOrderSerRate(data = {}) {
  Log('setOperatorOrderSerRate data:', data)
  try {
    const res = await Net.http('operator/set-commission-rate', { data })
    Log('setOperatorOrderSerRate res:', res)
    return res
  } catch (err) {
    Log('setOperatorOrderSerRate err:', err)
    throw err
  }
}

/** operator/set-pay-service-fee-channel
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.channel
*/
export async function setOperatorSerFeeChannel(data = {}) {
  Log('setOperatorSerFeeChannel data:', data)
  try {
    const res = await Net.http('operator/set-pay-service-fee-channel', { data })
    Log('setOperatorSerFeeChannel res:', res)
    return res
  } catch (err) {
    Log('setOperatorSerFeeChannel err:', err)
    throw err
  }
}

/** account/collect-account-detail
 * @param {Object} data
 * @param {*} data.user_id
*/
export async function operatorGathAccount(data = {}) {
  Log('operatorGathAccount data:', data)
  try {
    const res = await Net.http('account/collect-account-detail', { data })
    Log('operatorGathAccount res:', res)
    return res
  } catch (err) {
    Log('operatorGathAccount err:', err)
    throw err
  }
}

/** station/check-flag-hl
 * @param {Object} data
*/
export async function checkOperatorHaluo(data = {}) {
  Log('checkOperatorHaluo data:', data)
  try {
    const res = await Net.http('station/check-flag-hl', { data })
    Log('checkOperatorHaluo res:', res)
    return res
  } catch (err) {
    Log('checkOperatorHaluo err:', err)
    throw err
  }
}

/** operator/change-pay-channel
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.channel
*/
export async function setOperatorPayChannel(data = {}) {
  Log('setOperatorPayChannel data:', data)
  try {
    const res = await Net.http('operator/change-pay-channel', { data })
    Log('setOperatorPayChannel res:', res)
    return res
  } catch (err) {
    Log('setOperatorPayChannel err:', err)
    throw err
  }
}

/** user/enable-pre-recharge
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function operatorPreRechargeEnable(data = {}) {
  Log('operatorPreRechargeEnable data:', data)
  try {
    const res = await Net.http('user/enable-pre-recharge', { data })
    Log('operatorPreRechargeEnable res:', res)
    return res
  } catch (err) {
    Log('operatorPreRechargeEnable err:', err)
    throw err
  }
}

/** operator/set-operator-bf-pay
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function operatorFlagBfPay(data = {}) {
  Log('operatorFlagBfPay data:', data)
  try {
    const res = await Net.http('operator/set-operator-bf-pay', { data })
    Log('operatorFlagBfPay res:', res)
    return res
  } catch (err) {
    Log('operatorFlagBfPay err:', err)
    throw err
  }
}

/** operator/set-operator-insurance
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function operatorFlagInsurance(data = {}) {
  Log('operatorFlagInsurance data:', data)
  try {
    const res = await Net.http('operator/set-operator-insurance', { data })
    Log('operatorFlagInsurance res:', res)
    return res
  } catch (err) {
    Log('operatorFlagInsurance err:', err)
    throw err
  }
}

/** operator/set-flag-operator-customer-service-phone
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function operatorFlagCheckCustomerServicePhone(data = {}) {
  Log('operatorFlagCheckCustomerServicePhone data:', data)
  try {
    const res = await Net.http('operator/set-flag-operator-customer-service-phone', { data })
    Log('operatorFlagCheckCustomerServicePhone res:', res)
    return res
  } catch (err) {
    Log('operatorFlagCheckCustomerServicePhone err:', err)
    throw err
  }
}

/** operator/set-operator-real-id
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function operatorFlagRealIdVerify(data = {}) {
  Log('operatorFlagRealIdVerify data:', data)
  try {
    const res = await Net.http('operator/set-operator-real-id', { data })
    Log('operatorFlagRealIdVerify res:', res)
    return res
  } catch (err) {
    Log('operatorFlagRealIdVerify err:', err)
    throw err
  }
}

/** operator/set-operator-qgl-pay
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function operatorFlagQglPay(data = {}) {
  Log('operatorFlagQglPay data:', data)
  try {
    const res = await Net.http('operator/set-operator-qgl-pay', { data })
    Log('operatorFlagQglPay res:', res)
    return res
  } catch (err) {
    Log('operatorFlagQglPay err:', err)
    throw err
  }
}

/** operator/set-qgl-config
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.qgl_config
*/
export async function setOperatorQglConfig(data = {}) {
  Log('setOperatorQglConfig data:', data)
  try {
    const res = await Net.http('operator/set-qgl-config', { data })
    Log('setOperatorQglConfig res:', res)
    return res
  } catch (err) {
    Log('setOperatorQglConfig err:', err)
    throw err
  }
}

/** operator/set-operator-hl
 * @param {Object} data
 * @param {*} data.id
*/
export async function operatorFlagHello(data = {}) {
  Log('operatorFlagHello data:', data)
  try {
    const res = await Net.http('operator/set-operator-hl', { data })
    Log('operatorFlagHello res:', res)
    return res
  } catch (err) {
    Log('operatorFlagHello err:', err)
    throw err
  }
}

/** operator/set-operator-hl-config
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.config
*/
export async function setOperatorHlConfig(data = {}) {
  Log('setOperatorHlConfig data:', data)
  try {
    const res = await Net.http('operator/set-operator-hl-config', { data })
    Log('setOperatorHlConfig res:', res)
    return res
  } catch (err) {
    Log('setOperatorHlConfig err:', err)
    throw err
  }
}

/** operator/report-to-hello
 * @param {Object} data
 * @param {*} data.id
*/
export async function reportOperatorHello(data = {}) {
  Log('reportOperatorHello data:', data)
  try {
    const res = await Net.http('operator/report-to-hello', { data })
    Log('reportOperatorHello res:', res)
    return res
  } catch (err) {
    Log('reportOperatorHello err:', err)
    throw err
  }
}

/** operator/set-flag-card-global-available
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function operatorFlagCardGlobalAvailable(data = {}) {
  Log('operatorFlagCardGlobalAvailable data:', data)
  try {
    const res = await Net.http('operator/set-flag-card-global-available', { data })
    Log('operatorFlagCardGlobalAvailable res:', res)
    return res
  } catch (err) {
    Log('operatorFlagCardGlobalAvailable err:', err)
    throw err
  }
}

/** operator/set-report-strategy
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.report_strategy
 * @param {*} data.report_config
*/
export async function setOperatorReportStrategy(data = {}) {
  Log('setOperatorReportStrategy data:', data)
  try {
    const res = await Net.http('operator/set-report-strategy', { data })
    Log('setOperatorReportStrategy res:', res)
    return res
  } catch (err) {
    Log('setOperatorReportStrategy err:', err)
    throw err
  }
}

/** operator/change-pay-channel
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.channel
*/
export async function changeOperatorPayChannel(data = {}) {
  Log('changeOperatorPayChannel data:', data)
  try {
    const res = await Net.http('operator/change-pay-channel', { data })
    Log('changeOperatorPayChannel res:', res)
    return res
  } catch (err) {
    Log('changeOperatorPayChannel err:', err)
    throw err
  }
}

/** operator/set-flag-independent-wx-service
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function setOperatorFlagIndependentWxService(data = {}) {
  Log('setOperatorFlagIndependentWxService data:', data)
  try {
    const res = await Net.http('operator/set-flag-independent-wx-service', { data })
    Log('setOperatorFlagIndependentWxService res:', res)
    return res
  } catch (err) {
    Log('setOperatorFlagIndependentWxService err:', err)
    throw err
  }
}

/** operator/set-flag-independent-wx-mp
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function setOperatorFlagIndependentWxMp(data = {}) {
  Log('setOperatorFlagIndependentWxMp data:', data)
  try {
    const res = await Net.http('operator/set-flag-independent-wx-mp', { data })
    Log('setOperatorFlagIndependentWxMp res:', res)
    return res
  } catch (err) {
    Log('setOperatorFlagIndependentWxMp err:', err)
    throw err
  }
}

/** operator/set-flag-bf-postpay
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function setOperatorFlagBfPostpay(data = {}) {
  Log('setOperatorFlagBfPostpay data:', data)
  try {
    const res = await Net.http('operator/set-flag-bf-postpay', { data })
    Log('setOperatorFlagBfPostpay res:', res)
    return res
  } catch (err) {
    Log('setOperatorFlagBfPostpay err:', err)
    throw err
  }
}

/** operator/close-flag-invoice
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function closeOperatorFlagInvoice(data = {}) {
  Log('closeOperatorFlagInvoice data:', data)
  try {
    const res = await Net.http('operator/close-flag-invoice', { data })
    Log('closeOperatorFlagInvoice res:', res)
    return res
  } catch (err) {
    Log('closeOperatorFlagInvoice err:', err)
    throw err
  }
}

/** operator/close-flag-member-price
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function closeOperatorFlagMemberPrice(data = {}) {
  Log('closeOperatorFlagMemberPrice data:', data)
  try {
    const res = await Net.http('operator/close-flag-member-price', { data })
    Log('closeOperatorFlagMemberPrice res:', res)
    return res
  } catch (err) {
    Log('closeOperatorFlagMemberPrice err:', err)
    throw err
  }
}

/** operator/close-user-apply-refund
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function closeOperatorRefundApplication(data = {}) {
  Log('closeOperatorRefundApplication data:', data)
  try {
    const res = await Net.http('operator/close-user-apply-refund', { data })
    Log('closeOperatorRefundApplication res:', res)
    return res
  } catch (err) {
    Log('closeOperatorRefundApplication err:', err)
    throw err
  }
}

/** operator/close-flag-car-occupy-after-charge
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function closeOperatorFlagCarOccupyAfterCharge(data = {}) {
  Log('closeOperatorFlagCarOccupyAfterCharge data:', data)
  try {
    const res = await Net.http('operator/close-flag-car-occupy-after-charge', { data })
    Log('closeOperatorFlagCarOccupyAfterCharge res:', res)
    return res
  } catch (err) {
    Log('closeOperatorFlagCarOccupyAfterCharge err:', err)
    throw err
  }
}


/** === SubOperator === **/
/** operator/sub-account-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.name
 * @param {*} data.operator_id
*/
export async function getSubOperatorList(data = {}) {
  Log('getSubOperatorList data:', data)
  try {
    const res = await Net.http('operator/sub-account-list', { data })
    Log('getSubOperatorList res:', res)
    return res
  } catch (err) {
    Log('getSubOperatorList err:', err)
    throw err
  }
}

/** operator/save-sub-account 创建子账号 分销创建分销、直营创建直营
 * @param {Object} data
 * @param {*} data.operator_id 所属运营商 ID
 * @param {*} data.id 子账号 ID，`0` 表示新增
 * @param {*} data.mode 运营商模式
 * @param {*} data.username 登录账号
 * @param {*} data.password 登录密码
 * @param {*} data.phone 手机号
 * @param {*} data.alipay_account 支付宝账号
*/
export async function saveSubOperatorSimple(data = {}) {
  Log('saveSubOperatorSimple data:', data)
  try {
    const res = await Net.http('operator/save-sub-account', { data })
    Log('saveSubOperatorSimple res:', res)
    return res
  } catch (err) {
    Log('saveSubOperatorSimple err:', err)
    throw err
  }
}
/** /1/operator/save-sub-account 创建子账号 分销创建直营
 * @param {Object} data
 * @param {*} data.operator_id 所属运营商 ID
 * @param {*} data.id 子账号 ID，`0` 表示新增
 * @param {*} data.mode 运营商模式
 * @param {*} data.username 登录账号
 * @param {*} data.password 登录密码
 * @param {*} data.phone 手机号
 * @param {*} data.alipay_account 支付宝账号
*/
export async function saveSubOperatorComplex(data = {}) {
  Log('saveSubOperatorComplex data:', data)
  try {
    const res = await Net.http('operator/save-sub-account', { data })
    Log('saveSubOperatorComplex res:', res)
    return res
  } catch (err) {
    Log('saveSubOperatorComplex err:', err)
    throw err
  }
}
/** /2/operator/save-sub-account 创建子账号 分销创建直营
 * @param {Object} data
 * @param {*} data.operator_id 所属运营商 ID
 * @param {*} data.id 子账号 ID，`0` 表示新增
 * @param {*} data.mode 运营商模式
 * @param {*} data.username 登录账号
 * @param {*} data.password 登录密码
 * @param {*} data.phone 手机号
 * @param {*} data.alipay_account 支付宝账号
 * V2 新增参数
 * @param {*} data.name 子账号名称
 * @param {*} data.avatar 头像
 * @param {*} data.gender 性别
 * @param {*} data.province 省
 * @param {*} data.city 市
 * @param {*} data.county 区/县
 * @param {*} data.admin_logo 管理端 Logo
 * @param {*} data.admin_name 管理端名称
 * @param {*} data.app_name App 名称
 * @param {*} data.app_contact App 联系方式
 * @param {*} data.company_name 公司名称
 * @param {*} data.account_opening_info 开户资料 JSON
*/
export async function saveSubOperatorComplexV2(data = {}) {
  Log('saveSubOperatorComplex data:', data)
  try {
    const res = await Net.http('operator/save-sub-account', { data, versionMark: 2 })
    Log('saveSubOperatorComplex res:', res)
    return res
  } catch (err) {
    Log('saveSubOperatorComplex err:', err)
    throw err
  }
}

/** operator/delete-sub-account
 * @param {Object} data
 * @param {*} data.sub_account_id
*/
export async function deleteSubOperator(data = {}) {
  Log('deleteSubOperator data:', data)
  try {
    const res = await Net.http('operator/delete-sub-account', { data })
    Log('deleteSubOperator res:', res)
    return res
  } catch (err) {
    Log('deleteSubOperator err:', err)
    throw err
  }
}

/** operator/set-account-status
 * @param {Object} data
 * @param {*} data.sub_account_id
 * @param {*} data.status
*/
export async function setSubOperatorStatus(data = {}) {
  Log('setSubOperatorStatus data:', data)
  try {
    const res = await Net.http('operator/set-account-status', { data })
    Log('setSubOperatorStatus res:', res)
    return res
  } catch (err) {
    Log('setSubOperatorStatus err:', err)
    throw err
  }
}

/** operator/account-change-password
 * @param {Object} data
 * @param {*} data.sub_account_id
 * @param {*} data.password
*/
export async function subOperatorEditPwd(data = {}) {
  Log('subOperatorEditPwd data:', data)
  try {
    const res = await Net.http('operator/account-change-password', { data })
    Log('subOperatorEditPwd res:', res)
    return res
  } catch (err) {
    Log('subOperatorEditPwd err:', err)
    throw err
  }
}

/** org/distribution
 * @param {Object} data
 * @param {*} data.operator_member_id
 * @param {*} data.org_ids
 * @param {*} data.operator_id
*/
export async function subOperatorAllotOrg(data = {}) {
  Log('subOperatorAllotOrg data:', data)
  try {
    const res = await Net.http('org/distribution', { data })
    Log('subOperatorAllotOrg res:', res)
    return res
  } catch (err) {
    Log('subOperatorAllotOrg err:', err)
    throw err
  }
}

/** clearing-account/distribution
 * @param {Object} data
 * @param {*} data.target_operator_id
 * @param {*} data.clearing_account_ids
 * @param {*} data.operator_id
*/
export async function subOperatorAllotAccount(data = {}) {
  Log('subOperatorAllotAccount data:', data)
  try {
    const res = await Net.http('clearing-account/distribution', { data })
    Log('subOperatorAllotAccount res:', res)
    return res
  } catch (err) {
    Log('subOperatorAllotAccount err:', err)
    throw err
  }
}

/** operator/sub-operator-list
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.page
*/
export async function subOperatorSubList(data = {}) {
  Log('subOperatorSubList data:', data)
  try {
    const res = await Net.http('operator/sub-operator-list', { data })
    Log('subOperatorSubList res:', res)
    return res
  } catch (err) {
    Log('subOperatorSubList err:', err)
    throw err
  }
}

/** org/get-sub-org
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.page
*/
export async function subOperatorOrgList(data = {}) {
  Log('subOperatorOrgList data:', data)
  try {
    const res = await Net.http('org/get-sub-org', { data })
    Log('subOperatorOrgList res:', res)
    return res
  } catch (err) {
    Log('subOperatorOrgList err:', err)
    throw err
  }
}

/** clearing-account/get-sub-clearing-account
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.page
*/
export async function subOperatorSettlementList(data = {}) {
  Log('subOperatorSettlementList data:', data)
  try {
    const res = await Net.http('clearing-account/get-sub-clearing-account', { data })
    Log('subOperatorSettlementList res:', res)
    return res
  } catch (err) {
    Log('subOperatorSettlementList err:', err)
    throw err
  }
}

/** org/distribution-delete
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.operator_member_id
 * @param {*} data.org_ids
*/
export async function subOperatorOrgRemove(data = {}) {
  Log('subOperatorOrgRemove data:', data)
  try {
    const res = await Net.http('org/distribution-delete', { data })
    Log('subOperatorOrgRemove res:', res)
    return res
  } catch (err) {
    Log('subOperatorOrgRemove err:', err)
    throw err
  }
}

/** clearing-account/distribution-delete
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.target_operator_id
 * @param {*} data.clearing_account_ids
*/
export async function subOperatorSettlementRemove(data = {}) {
  Log('subOperatorSettlementRemove data:', data)
  try {
    const res = await Net.http('clearing-account/distribution-delete', { data })
    Log('subOperatorSettlementRemove res:', res)
    return res
  } catch (err) {
    Log('subOperatorSettlementRemove err:', err)
    throw err
  }
}


/** === OperatorCustom === **/
/** operator-custom/save
 * @param {Object} data
 * @param {*} data.operator_custom_id
 * @param {*} data.operator_id
 * @param {*} data.company_name
 * @param {*} data.admin_name
 * @param {*} data.admin_logo
 * @param {*} data.app_name
 * @param {*} data.app_contact
 * @param {*} data.after_pay_redirect_url
*/
export async function saveOperatorCustom(data = {}) {
  Log('saveOperatorCustom data:', data)
  try {
    const res = await Net.http('operator-custom/save', { data })
    Log('saveOperatorCustom res:', res)
    return res
  } catch (err) {
    Log('saveOperatorCustom err:', err)
    throw err
  }
}

/** operator-custom/detail-by-operator-id
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function getOperatorCustomDetail(data = {}) {
  Log('getOperatorCustomDetail data:', data)
  try {
    const res = await Net.http('operator-custom/detail-by-operator-id', { data })
    Log('getOperatorCustomDetail res:', res)
    return res
  } catch (err) {
    Log('getOperatorCustomDetail err:', err)
    throw err
  }
}

/** operator-custom/delete
 * @param {Object} data
 * @param {*} data.operator_custom_id
*/
export async function deleteOperatorCustom(data = {}) {
  Log('deleteOperatorCustom data:', data)
  try {
    const res = await Net.http('operator-custom/delete', { data })
    Log('deleteOperatorCustom res:', res)
    return res
  } catch (err) {
    Log('deleteOperatorCustom err:', err)
    throw err
  }
}

/** operator-custom/set-flag-admin
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function setOperatorCustomFlagAdmin(data = {}) {
  Log('setOperatorCustomFlagAdmin data:', data)
  try {
    const res = await Net.http('operator-custom/set-flag-admin', { data })
    Log('setOperatorCustomFlagAdmin res:', res)
    return res
  } catch (err) {
    Log('setOperatorCustomFlagAdmin err:', err)
    throw err
  }
}


/** === OperatorAd === **/
/** operator-ad-config/save
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.after_wx_h5_pay_redirect_url
 * @param {*} data.after_ali_h5_pay_redirect_url
 * @param {*} data.after_wx_mini_program_pay_redirect_url
 * @param {*} data.after_ali_mini_program_pay_redirect_url
*/
export async function saveOperatorAd(data = {}) {
  Log('saveOperatorAd data:', data)
  try {
    const res = await Net.http('operator-ad-config/save', { data })
    Log('saveOperatorAd res:', res)
    return res
  } catch (err) {
    Log('saveOperatorAd err:', err)
    throw err
  }
}

/** operator-ad-config/detail
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function getOperatorAdDetail(data = {}) {
  Log('getOperatorAdDetail data:', data)
  try {
    const res = await Net.http('operator-ad-config/detail', { data })
    Log('getOperatorAdDetail res:', res)
    return res
  } catch (err) {
    Log('getOperatorAdDetail err:', err)
    throw err
  }
}

/** operator-ad-config/set-flag-after-pay-redirect-url
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function setOperatorAdFlagAfterPayRedirectUrl(data = {}) {
  Log('setOperatorAdFlagAfterPayRedirectUrl data:', data)
  try {
    const res = await Net.http('operator-ad-config/set-flag-after-pay-redirect-url', { data })
    Log('setOperatorAdFlagAfterPayRedirectUrl res:', res)
    return res
  } catch (err) {
    Log('setOperatorAdFlagAfterPayRedirectUrl err:', err)
    throw err
  }
}


/** === OperatorPay === **/
/** operator-pay-config/update-operator-independent-pay
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function enableOperatorPay(data = {}) {
  Log('enableOperatorPay data:', data)
  try {
    const res = await Net.http('operator-pay-config/update-operator-independent-pay', { data })
    Log('enableOperatorPay res:', res)
    return res
  } catch (err) {
    Log('enableOperatorPay err:', err)
    throw err
  }
}

/** operator-pay-config/detail OperatorPay.detail
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function getOperatorPayDetail(data = {}) {
  Log('getOperatorPayDetail data:', data)
  try {
    const res = await Net.http('operator-pay-config/detail', { data })
    Log('getOperatorPayDetail res:', res)
    return res
  } catch (err) {
    Log('getOperatorPayDetail err:', err)
    throw err
  }
}

/** operator-pay-config/save
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.wx_mch_type
 * @param {*} data.flag_wx_independent
 * @param {*} data.wx_independent_app_id
 * @param {*} data.wx_mch_id
 * @param {*} data.wx_pay_key
 * @param {*} data.wx_cert_path
 * @param {*} data.alipay_app_id
 * @param {*} data.alipay_private_key
 * @param {*} data.alipay_public_key
 * @param {*} data.alipay_cert_path
 * @param {*} data.alipay_public_cert_path
 * @param {*} data.alipay_root_cert_path
 * @param {*} data.alipay_transfer_config
*/
export async function saveOperatorPay(data = {}) {
  Log('saveOperatorPay data:', data)
  try {
    const res = await Net.http('operator-pay-config/save', { data })
    Log('saveOperatorPay res:', res)
    return res
  } catch (err) {
    Log('saveOperatorPay err:', err)
    throw err
  }
}

/** operator-pay-config/set-fjnx-config
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function setOperatorPayFjnxConfig(data = {}) {
  Log('setOperatorPayFjnxConfig data:', data)
  try {
    const res = await Net.http('operator-pay-config/set-fjnx-config', { data })
    Log('setOperatorPayFjnxConfig res:', res)
    return res
  } catch (err) {
    Log('setOperatorPayFjnxConfig err:', err)
    throw err
  }
}

/** operator-pay-config/account-opening/save
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.legal_person_name
 * @param {*} data.legal_person_id_no
 * @param {*} data.legal_person_phone
 * @param {*} data.legal_person_id_card_front
 * @param {*} data.legal_person_id_card_back
 * @param {*} data.business_license
 * @param {*} data.unified_social_credit_code
 * @param {*} data.account_name
 * @param {*} data.bank_account_no
 * @param {*} data.bank_name
 * @param {*} data.bank_branch_name
 * @param {*} data.bank_branch_code
*/
export async function operatorPayMerchantAccountSave(data = {}) {
  Log('operatorPayMerchantAccountSave data:', data)
  try {
    const res = await Net.http('operator-pay-config/account-opening/save', { data })
    Log('operatorPayMerchantAccountSave res:', res)
    return res
  } catch (err) {
    Log('operatorPayMerchantAccountSave err:', err)
    throw err
  }
}

/** operator-pay-config/ocr/business-license
 * @param {Object} data
 * @param {*} data.img_url
*/
export async function operatorPayOcrBusinessLicense(data = {}) {
  Log('operatorPayOcrBusinessLicense data:', data)
  try {
    const res = await Net.http('operator-pay-config/ocr/business-license', { data })
    Log('operatorPayOcrBusinessLicense res:', res)
    return res
  } catch (err) {
    Log('operatorPayOcrBusinessLicense err:', err)
    throw err
  }
}


/** === OperatorPayScore === **/
/** wx-pay-score-account-application/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.operator_id
*/
export async function getOperatorPayScoreList(data = {}) {
  Log('getOperatorPayScoreList data:', data)
  try {
    const res = await Net.http('wx-pay-score-account-application/list', { data })
    Log('getOperatorPayScoreList res:', res)
    return res
  } catch (err) {
    Log('getOperatorPayScoreList err:', err)
    throw err
  }
}

/** wx-pay-score-account-application/apply
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.operator_pay_config_id
*/
export async function operatorPayScoreApply(data = {}) {
  Log('operatorPayScoreApply data:', data)
  try {
    const res = await Net.http('wx-pay-score-account-application/apply', { data })
    Log('operatorPayScoreApply res:', res)
    return res
  } catch (err) {
    Log('operatorPayScoreApply err:', err)
    throw err
  }
}

/** wx-pay-score-account-application/query
 * @param {Object} data
 * @param {*} data.id
*/
export async function queryOperatorPayScore(data = {}) {
  Log('queryOperatorPayScore data:', data)
  try {
    const res = await Net.http('wx-pay-score-account-application/query', { data })
    Log('queryOperatorPayScore res:', res)
    return res
  } catch (err) {
    Log('queryOperatorPayScore err:', err)
    throw err
  }
}

/** wx-pay-score-account-application/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getOperatorPayScoreDetail(data = {}) {
  Log('getOperatorPayScoreDetail data:', data)
  try {
    const res = await Net.http('wx-pay-score-account-application/detail', { data })
    Log('getOperatorPayScoreDetail res:', res)
    return res
  } catch (err) {
    Log('getOperatorPayScoreDetail err:', err)
    throw err
  }
}


/** === OperatorClient === **/
/** app/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getOperatorClientDetail(data = {}) {
  Log('getOperatorClientDetail data:', data)
  try {
    const res = await Net.http('app/detail', { data })
    Log('getOperatorClientDetail res:', res)
    return res
  } catch (err) {
    Log('getOperatorClientDetail err:', err)
    throw err
  }
}

/** app/save-wx-mini-program
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.operator_id
 * @param {*} data.app_id
 * @param {*} data.app_secret
*/
export async function operatorClientWxAppletSave(data = {}) {
  Log('operatorClientWxAppletSave data:', data)
  try {
    const res = await Net.http('app/save-wx-mini-program', { data })
    Log('operatorClientWxAppletSave res:', res)
    return res
  } catch (err) {
    Log('operatorClientWxAppletSave err:', err)
    throw err
  }
}

/** app/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.operator_id
 * @param {*} data.type
 * @param {*} data.wx_service_title
 * @param {*} data.flag_independent_wx_service
 * @param {*} data.wx_service_app_id
 * @param {*} data.wx_service_app_secret
 * @param {*} data.wx_service_qr_code_path
 * @param {*} data.flag_wx_service_follow
 * @param {*} data.wx_service_start_template_id
 * @param {*} data.wx_service_finish_template_id
 * @param {*} data.wx_service_order_stop_template_id
 * @param {*} data.wx_service_order_refund_template_id
 * @param {*} data.wx_service_close_cabinet_door_template_id
 * @param {*} data.wx_service_insurance_pay_template_id
 * @param {*} data.wx_service_insurance_refund_template_id
*/
export async function operatorClientWxOfficialSave(data = {}) {
  Log('operatorClientWxOfficialSave data:', data)
  try {
    const res = await Net.http('app/save', { data })
    Log('operatorClientWxOfficialSave res:', res)
    return res
  } catch (err) {
    Log('operatorClientWxOfficialSave err:', err)
    throw err
  }
}


/** === OperatorWxFile === **/
/** wx-file/save
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.wx_service_file_name
 * @param {*} data.wx_service_file_content
*/
export async function saveOperatorWxFile(data = {}) {
  Log('saveOperatorWxFile data:', data)
  try {
    const res = await Net.http('wx-file/save', { data })
    Log('saveOperatorWxFile res:', res)
    return res
  } catch (err) {
    Log('saveOperatorWxFile err:', err)
    throw err
  }
}

/** wx-file/detail
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function getOperatorWxFileDetail(data = {}) {
  Log('getOperatorWxFileDetail data:', data)
  try {
    const res = await Net.http('wx-file/detail', { data })
    Log('getOperatorWxFileDetail res:', res)
    return res
  } catch (err) {
    Log('getOperatorWxFileDetail err:', err)
    throw err
  }
}


/** === OperatorSms === **/
/** app/save-sms
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.sms_json
*/
export async function saveOperatorSms(data = {}) {
  Log('saveOperatorSms data:', data)
  try {
    const res = await Net.http('app/save-sms', { data })
    Log('saveOperatorSms res:', res)
    return res
  } catch (err) {
    Log('saveOperatorSms err:', err)
    throw err
  }
}

/** app/sms-detail
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function getOperatorSmsDetail(data = {}) {
  Log('getOperatorSmsDetail data:', data)
  try {
    const res = await Net.http('app/sms-detail', { data })
    Log('getOperatorSmsDetail res:', res)
    return res
  } catch (err) {
    Log('getOperatorSmsDetail err:', err)
    throw err
  }
}


/** === OperatorActivationCode === **/
/** operator-activation-code/list
 * @param {Object} data
 * @param {*} data.status
 * @param {*} data.page
*/
export async function getOperatorActivationCodeList(data = {}) {
  Log('getOperatorActivationCodeList data:', data)
  try {
    const res = await Net.http('operator-activation-code/list', { data })
    Log('getOperatorActivationCodeList res:', res)
    return res
  } catch (err) {
    Log('getOperatorActivationCodeList err:', err)
    throw err
  }
}

/** operator-activation-code/create
 * @param {Object} data
 * @param {*} data.count
 * @param {*} data.mode
 * @param {*} data.flag_grant_all_auth
*/
export async function createOperatorActivationCode(data = {}) {
  Log('createOperatorActivationCode data:', data)
  try {
    const res = await Net.http('operator-activation-code/create', { data })
    Log('createOperatorActivationCode res:', res)
    return res
  } catch (err) {
    Log('createOperatorActivationCode err:', err)
    throw err
  }
}


/** === BenefitPackageOrder === **/
/** benefit-package-order/create
 * @param {Object} data
 * @param {*} data.amount
 * @param {*} data.price
*/
export async function createBenefitPackageOrder(data = {}) {
  Log('createBenefitPackageOrder data:', data)
  try {
    const res = await Net.http('benefit-package-order/create', { data })
    Log('createBenefitPackageOrder res:', res)
    return res
  } catch (err) {
    Log('createBenefitPackageOrder err:', err)
    throw err
  }
}

/** benefit-package-order/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.status
*/
export async function getBenefitPackageOrderList(data = {}) {
  Log('getBenefitPackageOrderList data:', data)
  try {
    const res = await Net.http('benefit-package-order/list', { data })
    Log('getBenefitPackageOrderList res:', res)
    return res
  } catch (err) {
    Log('getBenefitPackageOrderList err:', err)
    throw err
  }
}

/** benefit-package-order/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getBenefitPackageOrderDetail(data = {}) {
  Log('getBenefitPackageOrderDetail data:', data)
  try {
    const res = await Net.http('benefit-package-order/detail', { data })
    Log('getBenefitPackageOrderDetail res:', res)
    return res
  } catch (err) {
    Log('getBenefitPackageOrderDetail err:', err)
    throw err
  }
}


/** === WhiteList === **/
/** white-panel/save
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.username
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.user_type
*/
export async function saveWhiteList(data = {}) {
  Log('saveWhiteList data:', data)
  try {
    const res = await Net.http('white-panel/save', { data })
    Log('saveWhiteList res:', res)
    return res
  } catch (err) {
    Log('saveWhiteList err:', err)
    throw err
  }
}

/** white-panel/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.phone
 * @param {*} data.username
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.user_type
*/
export async function getWhiteListList(data = {}) {
  Log('getWhiteListList data:', data)
  try {
    const res = await Net.http('white-panel/list', { data })
    Log('getWhiteListList res:', res)
    return res
  } catch (err) {
    Log('getWhiteListList err:', err)
    throw err
  }
}

/** white-panel/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteWhiteList(data = {}) {
  Log('deleteWhiteList data:', data)
  try {
    const res = await Net.http('white-panel/delete', { data })
    Log('deleteWhiteList res:', res)
    return res
  } catch (err) {
    Log('deleteWhiteList err:', err)
    throw err
  }
}

/** white-panel/delete-batch
 * @param {Object} data
 * @param {*} data.ids
*/
export async function deleteWhiteListBatch(data = {}) {
  Log('deleteWhiteListBatch data:', data)
  try {
    const res = await Net.http('white-panel/delete-batch', { data })
    Log('deleteWhiteListBatch res:', res)
    return res
  } catch (err) {
    Log('deleteWhiteListBatch err:', err)
    throw err
  }
}

/** white-panel/update-username
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.username
*/
export async function updateWhiteListUsername(data = {}) {
  Log('updateWhiteListUsername data:', data)
  try {
    const res = await Net.http('white-panel/update-username', { data })
    Log('updateWhiteListUsername res:', res)
    return res
  } catch (err) {
    Log('updateWhiteListUsername err:', err)
    throw err
  }
}

/** white-panel/action-list
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.user_id
 * @param {*} data.page
*/
export async function whiteListActionList(data = {}) {
  Log('whiteListActionList data:', data)
  try {
    const res = await Net.http('white-panel/action-list', { data })
    Log('whiteListActionList res:', res)
    return res
  } catch (err) {
    Log('whiteListActionList err:', err)
    throw err
  }
}
